import React from 'react';
import Icon from './Icon';

const DrawPolygonIcon = (props) => (
    <Icon {...props}>
        <path
            d="M16 18.5C16 19.8807 17.1193 21 18.5 21C19.8807 21 21 19.8807 21 18.5C21 17.1193 19.8807 16 18.5 16M16 18.5C16 17.1193 17.1193 16 18.5 16M16 18.5H8M18.5 16V8M8 18.5C8 19.8807 6.88071 21 5.5 21C4.11929 21 3 19.8807 3 18.5C3 17.1193 4.11929 16 5.5 16M8 18.5C8 17.1193 6.88071 16 5.5 16M5.5 16V8M5.5 8C4.11929 8 3 6.88071 3 5.5C3 4.11929 4.11929 3 5.5 3C6.88071 3 8 4.11929 8 5.5M5.5 8C6.88071 8 8 6.88071 8 5.5M8 5.5H16M18.5 8C17.1193 8 16 6.88071 16 5.5M18.5 8C19.8807 8 21 6.88071 21 5.5C21 4.11929 19.8807 3 18.5 3C17.1193 3 16 4.11929 16 5.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default DrawPolygonIcon;
